import { useEvent } from 'context/events/Event';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';
import usePanelPermissions from 'hooks/usePanelPermissions';
import { PERMISSIONS } from 'helpers/panelPermissions';
import { tabRestriction } from 'helpers/eventCollaboration';
import { useDetailVisible } from 'context/dash/DetailVisible';
import { Lock } from 'lucide-react';

// `permissions`: para quem entrou por uma equipe, a aba só aparece com alguma delas.
const items = {
    detail: { name: 'detail', label: 'Visão Geral', permissions: [PERMISSIONS.EVENTS_VIEW] },
    tickets: { name: 'tickets', label: 'Ingressos', permissions: [PERMISSIONS.EVENTS_VIEW] },
    products: { name: 'products', label: 'Produtos', permissions: [PERMISSIONS.EVENTS_VIEW] },
    // Pedidos fica logo depois do que se vende e antes de quem vem: a leitura da
    // barra passa a ser "o que ofereço → o que foi vendido → quem entra".
    orders: { name: 'orders', label: 'Pedidos', permissions: [PERMISSIONS.ORDERS_VIEW] },
    participant: { name: 'participant', label: 'Participantes', permissions: [PERMISSIONS.PARTICIPANTS_VIEW] },
    permissions: { name: 'permissions', label: 'Permissões', permissions: [PERMISSIONS.TEAMS_VIEW] },
    promotionalCode: { name: 'promotionalCode', label: 'Códigos promocionais', permissions: [PERMISSIONS.COUPONS_VIEW] },
    expenses: { name: 'expenses', label: 'Despesas', permissions: [PERMISSIONS.EVENTS_SALES_VIEW] },
    additional: { name: 'additional', label: 'Adicionais', permissions: [PERMISSIONS.EVENTS_VIEW] },
};

export default function Tab({ toogleTab, selectedTab, hasTickets, hasProducts, availableProducts }) {
    const { event } = useEvent();
    const { detailVisible } = useDetailVisible();
    const { can } = usePanelPermissions();

    const [isTicketsLoaded, setIsTicketsLoaded] = useState(false);
    const [isProductsLoaded, setIsProductsLoaded] = useState(false);

    useEffect(() => {
        const checkTickets = async () => {
            await new Promise(resolve => setTimeout(resolve, 1000));
            setIsTicketsLoaded(true);
        };

        checkTickets();
    }, [hasTickets]);

    useEffect(() => {
        const checkProducts = async () => {
            await new Promise(resolve => setTimeout(resolve, 1000));
            setIsProductsLoaded(true);
        };

        checkProducts();
    }, [hasProducts]);


    return (
        <ContainerTab>
            <StyledTab>
                {Object.values(items).filter((item) => can(...item.permissions)).map((item) => (
                    <TabItem
                        key={item.name}
                        onClick={() =>
                            (item.name !== 'products' ||
                                (item.name === 'products' && isProductsLoaded && (hasProducts || (availableProducts && availableProducts.length > 0)))
                            )
                                ? toogleTab(item.name)
                                : null
                        }

                        active={selectedTab === item.name}
                        disabled={
                            (item.name === items.products.name && (!availableProducts || availableProducts.length === 0) && !hasProducts) ||
                            (item.name === items.orders.name && !event) ||
                            (item.name === items.participant.name && !event) ||
                            (item.name === items.permissions.name && !event) ||
                            (item.name === items.additional.name && !event) ||
                            (item.name === items.promotionalCode.name && !event)
                        }


                    >
                        {item.label}
                        {/* Evento em colaboração: a aba segue na barra, mas bloqueada. */}
                        {tabRestriction(detailVisible, item.name) && (
                            <LockedMark title='Sem acesso a esta página' aria-label='sem acesso'>
                                <Lock size={12} aria-hidden='true' />
                            </LockedMark>
                        )}
                    </TabItem>
                ))}
            </StyledTab>
        </ContainerTab>

    );
}

const LockedMark = styled.span`
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    color: ${colors.nightLight};
`;

const ContainerTab = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
`

const StyledTab = styled(Row)`
    width: 100%;
    margin-top: 15px;
    display: flex;
    align-items: center;
    gap: 4px;
    overflow-x: auto;
    background-color: ${colors.neutralLight};
    border-radius: 10px;
    padding: 4px;

    /* border-bottom: 1px solid ${colors.primaryDashboard}; */
`;

const TabItem = styled.div`
    cursor: pointer;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    /* As abas dividem a barra inteira: flex-grow reparte a sobra e
       min-width: max-content impede que o rótulo quebre quando não há sobra —
       aí a barra volta a rolar horizontalmente. */
    flex: 1 0 auto;
    min-width: max-content;
    padding: 0 14px;
    text-align: center;
    white-space: nowrap;
    color: ${colors.nightDark};
    font-weight: 600;
    transition: all ease 0.15s;
    border-radius: 8px;


    @media screen and (min-width: ${breakpoints.lg}) {
        ${({ disabled }) => !disabled && `
            &:hover {
                color: ${panelAccent(colors.occasionalPurple)};
            }
        `}
    }
   
    ${({ disabled }) => disabled && `
        cursor: not-allowed;
        opacity: 0.5;
    `}

    ${({ active }) => active && `
        color: ${panelAccent(colors.occasionalPurple)};
        background-color: ${panelAccentAlpha(colors.occasionalPurple, '0A')};
        // border-bottom: 2px solid ${panelAccent(colors.occasionalPurple)};
    `}
    
`;